import { createElement as rc, forwardRef, useLayoutEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import useEnsureRef from '../hooks/useEnsureRef';
import styled from '../styled';

const _View = styled.div.attrs(props => ({ ...props, name: props.name || 'view' }))`
    display: ${props => (props.block ? 'block' : 'flex')};
    overflow: hidden;
`;
/**
 * @param {{ onClick?: (e: any) => void, onKeyDown?: (e: any) => void, [key: string]: any }} props
 */
const View = function View(props, passedRef) {
    const ref = useEnsureRef(passedRef);

    // Create a method to measure the size of this component.  This needs to be consistent between
    // react native and react web.
    useLayoutEffect(() => {
        if (ref.current != null) {
            ref.current.measureRect = async () => {
                return ref.current.getBoundingClientRect();
            };
        }
    }, [ref]);

    const onKeyDown = useCallback(
        e => {
            if (e.key === 'Enter') {
                props?.onClick?.(e);
            }
            props?.onKeyDown?.(e);
        },
        [props]
    );

    return rc(_View, { ...props, ref, onKeyDown });
};

View.propTypes = {
    onClick: PropTypes.func,
    onKeyDown: PropTypes.func
};
export default forwardRef(View);
